export default function teamReducer(state = { null: { local: [], database: [], status: {} } }, action) {
  switch (action.type) {
    case 'LOAD_TSG_AUDIT_RECENT_SUCCESS':
      return standardReturn(state, action.page, action.database);
    default:
      return state;
  }
}

/* Create a local copy for editing and sort it */
function standardReturn(state, page, database) {
  database = database.sort(sort);
  const local = [];
  for (const entry of database) {
    try {
      entry.events = JSON.parse(entry.events);
    } finally {
      local.push(Object.assign({}, entry));
    }
  }
  state[page] = { local, database, status: {} };
  return Object.assign({}, state);
}

function sort(a, b) {
  if (a.update_timestamp < b.update_timestamp) { return 1; }
  if (a.update_timestamp > b.update_timestamp) { return -1; }
  return 0;
}
